"use client";

import dynamic from "next/dynamic";

export const Search = dynamic(() => import("./Search").then((mod) => mod.Search));
